export const initPixels = (pixels) => {
  if (!pixels || !Array.isArray(pixels)) return;

  const head = document.head;

  let hasFb = false;
  let hasTiktok = false;

  pixels.forEach((pixel) => {
    if (!pixel.id || !pixel.type) return;

    if (pixel.type.toLowerCase() === 'meta' || pixel.type.toLowerCase() === 'facebook') {
      if (!hasFb) {
        // Init base script
        const script = document.createElement('script');
        script.innerHTML = `
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
        `;
        head.appendChild(script);
        hasFb = true;
      }

      const initScript = document.createElement('script');
      initScript.innerHTML = `fbq('init', '${pixel.id}');`;
      head.appendChild(initScript);

      const noscript = document.createElement('noscript');
      noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${pixel.id}&ev=PageView&noscript=1"/>`;
      document.body.appendChild(noscript);
    }
    else if (pixel.type.toLowerCase() === 'tiktok') {
      if (!hasTiktok) {
        const script = document.createElement('script');
        script.innerHTML = `
          !function (w, d, t) {
            w.TiktokAnalyticsObject = t;
            var ttq = w[t] = w[t] || [];
            ttq.methods = ["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"];
            ttq.setAndDefer = function(t, e) {
              t[e] = function() {
                t.push([e].concat(Array.prototype.slice.call(arguments,0)))
              }
            };
            for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
            ttq.instance = function(t) {
              for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++)
                ttq.setAndDefer(e, ttq.methods[n]);
              return e
            };
            ttq.load = function(e, n) {
              var r = "https://analytics.tiktok.com/i18n/pixel/events.js", o = n && n.partner;
              ttq._i = ttq._i || {}, ttq._i[e] = [], ttq._i[e]._u = r;
              ttq._t = ttq._t || {}, ttq._t[e] = +new Date;
              ttq._o = ttq._o || {}, ttq._o[e] = n || {};
              n = d.createElement("script");
              n.type = "text/javascript"; n.async = !0;
              n.src = r + "?sdkid=" + e + "&lib=" + t;
              e = d.getElementsByTagName("script")[0];
              e.parentNode.insertBefore(n, e)
            };
          }(window, document, 'ttq');
        `;
        head.appendChild(script);
        hasTiktok = true;
      }

      const initScript = document.createElement('script');
      initScript.innerHTML = `ttq.load('${pixel.id}');`;
      head.appendChild(initScript);
    }
    else if (pixel.type.toLowerCase() === 'snapchat') {
      const script = document.createElement('script');
      script.innerHTML = `
        (function(e,t,n){if(e.snaptr)return;var a=e.snaptr=function()
        {a.handleRequest?a.handleRequest.apply(a,arguments):a.queue.push(arguments)};
        a.queue=[];var s='script';r=t.createElement(s);r.async=!0;
        r.src=n;var u=t.getElementsByTagName(s)[0];
        u.parentNode.insertBefore(r,u);})(window,document,
        'https://sc-static.net/scevent.min.js');

        snaptr('init', '${pixel.id}');
        snaptr('track', 'PAGE_VIEW');
      `;
      head.appendChild(script);
    }
    else if (pixel.type.toLowerCase() === 'google') {
      const scriptAsync = document.createElement('script');
      scriptAsync.async = true;
      scriptAsync.src = `https://www.googletagmanager.com/gtag/js?id=${pixel.id}`;
      head.appendChild(scriptAsync);

      const scriptInit = document.createElement('script');
      scriptInit.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${pixel.id}');
      `;
      head.appendChild(scriptInit);
    }
  });

  // Call PageView after loading all pixels
  if (hasFb) {
    const fbPv = document.createElement('script');
    fbPv.innerHTML = `fbq('track', 'PageView');`;
    head.appendChild(fbPv);
  }

  if (hasTiktok) {
    const ttPv = document.createElement('script');
    ttPv.innerHTML = `ttq.page();`;
    head.appendChild(ttPv);
  }
};
